import React from "react";
import { CTAButton } from "./CTAButton";
type SectionProps = {
  id?: string;
  tone?: "ink" | "navy";
  cta?: string;
  children: React.ReactNode;
};
export function Section({
  id,
  tone = "ink",
  cta,
  children
}: SectionProps) {
  return <section id={id} className={`w-full ${tone === "ink" ? "bg-ink" : "bg-navy"}`} data-id="element-279" data-mp="3fy84c25few05">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 md:py-24" data-id="element-280" data-mp="3kw9oyrii33dq">
        {children}
        {cta && <div className="mt-12 flex flex-col items-center gap-3 text-center" data-id="element-281" data-mp="cg6n52e2k8xb">
            <CTAButton label={cta} data-id="element-282" data-mp="hdgbeepq2ejk" />
            <p className="text-xs text-muted" data-id="element-283" data-mp="hgui1z5f59wt">One-time payment · Instant access · 7-day guarantee</p>
          </div>}
      </div>
    </section>;
}
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  intro
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-284" data-mp="106arjbz30cpd">
      {eyebrow && <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-285" data-mp="2zk27zxw25mj5">{eyebrow}</p>}
      <h2 className="font-serif text-[2rem] font-bold leading-[1.12] text-cream sm:text-5xl" data-id="element-286" data-mp="2uma5yb1p8k18">{title}</h2>
      {intro && <div className="mt-5 text-base leading-relaxed text-muted sm:text-lg" data-id="element-287" data-mp="38dp11g8vsbon">{intro}</div>}
    </div>;
}